<template>
	<div class="container">
        <img :src="bgImg" alt="" @click.stop="downLoad">
        <div class="wechat-tips" v-if="isShow" style="display: block;">
            <img :src="imgTip" alt="">
        </div>
	</div>
</template>
<script>
import store from '@/store/store'
import { Params,loading } from '@/util/util.js'
import bgImg from '../assets/download-bg.png'
import Qs from 'qs'
	export default {//
		name: 'marketing',
		data (){
			return {
				browser:{
					versions:function(){
							var u = navigator.userAgent, app = navigator.appVersion;
							return {
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
                androidChrome:u.match(/Chrome\/([\d.]+)/),// android chrome
                iosChrome: u.match(/CriOS\/([\d.]+)/), // ios chrome
                iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                safari: u.indexOf('Safari') > -1 && u.indexOf("Chrome") < 1, //是否safari
                weixin: u.indexOf('MicroMessenger') > -1, //是否微信
                qq: u.indexOf('QQ')>-1//是否QQ
							};
					}(),
					language:(navigator.browserLanguage || navigator.language).toLowerCase()
                },
                AndroidDownload: '',
                IosDownload: '',
                isShow: false,
                imgTip: require('../assets/pop.png'),
                bgImg: bgImg
			}
		},
		created(){
            this.$store.commit('inWhichPage',{page:'marketing'});
		},
		watch:{
			
		},
		methods:{
			downLoad(){
                // 是否微信浏览器
                if(this.browser.versions.weixin && !this.browser.versions.ios){
                    this.isShow = true;
                } else if(this.browser.versions.ios){
                    window.location.href = 'https://apps.apple.com/app/apple-store/id1473975969?pt=120033782&ct=zhibo&mt=8';
                } else if(this.browser.versions.android){
                    window.location.href = 'https://apps.tiduhn.cn/venus_GDT05_2.11.2_5.apk';
                }
            }
        },
		mounted(){
			this.downLoad();
		}
	}
</script>
<style scoped>
	*{
        margin: 0;
        padding: 0;
    }
    html,body{
        width: 100%;
        height: 100%;
    }
    .container{
        width: 100vw;
        height: auto;
        background-color: #2d303a;
        background: transparent url('../assets/download-bg.png') no-repeat;
        background-size: cover;
        overflow: hidden;
    }
    .container>img{
        width: 100%;
    }
    .wechat-tips{
        display: none;
        position: fixed;
        z-index: 1000;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
		background:rgba(0,0,0,0.8);
    }
    .wechat-tips img{
        width: 18rem;
        position: absolute;
        top: 10px;
        right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/mobilPage/marketing.vue